





















































import {Component, Prop, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'
import DriverPasswordRequest from '../../model/request/DriverPasswordRequest'
import Motorista from '../../model/resource/Motorista'
const sha1 = require('sha1')

@Component
export default class ModalDriverPassword extends Vue {
  motorista = new Motorista()
  request = new DriverPasswordRequest()
  password = ''
  confirmPassword = ''

  async persistPassword() {
    if (!this.password) {
      Helper.abort('modal.modalDriverPassword.error.passwordCannotBeEmpty')
    }

    if (!this.confirmPassword) {
      Helper.abort('modal.modalDriverPassword.error.confirmPasswordCannotBeEmpty')
    }

    if (this.password.length < 5) {
      Helper.abort('modal.modalDriverPassword.error.invalidPasswordLength')
    }

    if (this.password !== this.confirmPassword) {
      Helper.abort('modal.modalDriverPassword.error.passwordDontMatch')
    }

    this.request.idDriver = this.motorista.$id
    this.request.temporaryPassword = sha1(this.password)

    await Motorista.persistTemporaryPassword(this.request)
    Helper.success('system.success.persist')
    this.close()
  }

  close() {
    this.$modal.close('modalDriverPassword')
  }

  async openEvent(driver: Motorista) {
    this.motorista = driver
    this.$emit('open')
  }

  closeEvent() {
    this.password = ''
    this.confirmPassword = ''
    this.$emit('close')
  }

}
